export function IllustrationCompliance({ className }: { className?: string }) {
  return (
    <img
      className={className}
      src="/images/atelier-inspection.webp"
      alt="Inspection qualité sous microscope"
      loading="lazy"
      style={{ borderRadius: 'var(--radius-md)', objectFit: 'cover' }}
    />
  );
}
